import { render } from "./Product.vue?vue&type=template&id=f658159a&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=f658159a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f658159a"

export default script